export const TAGS = [
  { label: 'Art', disabled: false, value: 'Art' },
  { label: 'Business', disabled: false, value: 'Business' },
  { label: 'Charts', disabled: false, value: 'Charts' },
  { label: 'Design', disabled: false, value: 'Design' },
  { label: 'Engineering', disabled: false, value: 'Engineering' },
  { label: 'Finance', disabled: false, value: 'Finance' },
  { label: 'Maps', disabled: false, value: 'Maps' },
  { label: 'Math', disabled: false, value: 'Math' },
  { label: 'Physics', disabled: false, value: 'Physics' },
  { label: 'Science', disabled: false, value: 'Science' },
  { label: 'Test', disabled: false, value: 'Test' },
];



// WEBPACK FOOTER //
// ./src/helpers/tagsHelper.js